import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { buttonStyle } from '../buttons/styles';
import { LayerChange } from '../icons';
import Tooltip from '../tooltip';

import FormGroup from '@material-ui/core/FormGroup';
import Paper from '@material-ui/core/Paper';
import Divider from '@material-ui/core/Divider';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import Checkbox from '@material-ui/core/Checkbox';

const styles = theme => ({
	button: buttonStyle(theme),
	buttonActive: Object.assign(buttonStyle(theme), {
		backgroundColor: theme.palette.action.hover,
		color: theme.palette.action.hoverText
	}),
	label: {}
});

const nameMap = {
	wmsLayer: 'Tradicionālā karte',
	wmsBWLayer: 'Melnbaltā karte',
	photoLayer: 'Ortofoto karte',
	topoLayer: 'Topogrāfiskā karte',
	topo75Layer: 'Topogrāfiskā (1921-1940)',
	lidarLayer: 'Zemes virsmas modelis'
}

class LayerSelect extends Component {
	constructor(props) {
		super(props);

		this.state = {
			open: false
		};

		this.handleChange = this.handleChange.bind(this);
		this.handleDataLayerChange = this.handleDataLayerChange.bind(this);
	}

	handleChange(event) {
		this.props.switchMapHandler(event.target.value);
	}

	handleDataLayerChange(event) {
		const newVisibilityState = event.target.checked;
		this.props.toggleDataLayer(event.target.name, newVisibilityState);
	}

	renderEntries(entries, dataLayers, currentLayer, classes, disabledLayers) {
		var key = 0;

		return (
			<List>
				<FormControl component='fieldset' style={{ paddingLeft: 10 }}>
					<RadioGroup name='basemap' onClick={this.handleChange}>
						{entries.map(entry => (
							<FormControlLabel
								style={{ height: 33 }}
								key={key++}
								value={entry}
								control={<Radio disabled={(disabledLayers.indexOf(entry) !== -1)} checked={currentLayer === entry} />}
								label={
									<div style={{ color: '#515151' }}>
										{nameMap[entry] || 'Karte'}
									</div>
								}
							/>
						))}
					</RadioGroup>
				</FormControl>
			</List>
		);
	}

	render() {
		const { classes, mapLayers, activeLayer } = this.props;
		const { open } = this.state;

		const dataLayers = {};

		var activeStyle = classes.buttonActive;
		var defaultStyle = classes.button;

		var disabledLayers = [];

		var layerToShow = activeLayer;
		
		return (
			<div style={{ width: '40px', margin: '0 5px 0 0' }}>
				<div style={{ width: '40px' }}>
					<Button
						onClick={() => {
							this.setState({ open: !this.state.open });
						}}
						raised='true'
						className={open ? activeStyle : defaultStyle}>
						<Tooltip title={'Kartes slāņu izvēle'}>
							<LayerChange />
						</Tooltip>
					</Button>
				</div>
				{open && (
					<Paper
						style={{
							width: '225px',
							position: 'relative',
							right: window.innerWidth <= 546 ? 0 : 192 + 'px',
							top: '4px',
							borderRadius: '0px'
						}}>
						<div>{this.renderEntries(mapLayers, dataLayers, layerToShow, classes, disabledLayers)}</div>
					</Paper>
				)}
			</div>
		);
	}
}

LayerSelect.propTypes = {
	dataLayers: PropTypes.object,
	classes: PropTypes.object,
	activeLayer: PropTypes.string,
	mapLayers: PropTypes.array,
	switchMapHandler: PropTypes.func
};

export default withStyles(styles)(LayerSelect);
